import { render } from "./GalleryCard.vue?vue&type=template&id=4dda78b0&scoped=true&ts=true"
import script from "./GalleryCard.ts?vue&type=script&lang=ts"
export * from "./GalleryCard.ts?vue&type=script&lang=ts"

import "./GalleryCard.scss?vue&type=style&index=0&id=4dda78b0&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dda78b0"]])

export default __exports__